export function operacaoPreRecebimentoListaInRequest(params = {}) {
  return {
    type: '@operacaoprerecebimentolista/OPERACAOPRERECEBIMENTOLISTA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoPreRecebimentoLista(prri_nf) {
  return {
    type: '@operacaoprerecebimentolista/FIND_OPERACAOPRERECEBIMENTOLISTA',
    payload: { prri_nf },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoprerecebimentolista/FAILED_REQUEST',
  };
}

export function deleteOperacaoPreRecebimentoLista(prri_nf, params) {
  return {
    type: '@operacaoprerecebimentolista/DELETE_OPERACAOPRERECEBIMENTOLISTA',
    payload: { prri_nf, params },
  };
}

export function updateOperacaoPreRecebimentoLista(operacaoprerecebimentolista, params) {
  return {
    type: '@operacaoprerecebimentolista/UPDATE_OPERACAOPRERECEBIMENTOLISTA',
    payload: { operacaoprerecebimentolista, params },
  };
}

export function storeOperacaoPreRecebimentoLista(operacaoprerecebimentolista, params) {
  return {
    type: '@operacaoprerecebimentolista/STORE_OPERACAOPRERECEBIMENTOLISTA',
    payload: { operacaoprerecebimentolista, params },
  };
}

export function successInRequest(
  operacaoprerecebimentolista,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoprerecebimentolista/SUCCESS_IN_REQUEST',
    payload: { operacaoprerecebimentolista, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoprerecebimentolista) {
  return {
    type: '@operacaoprerecebimentolista/SUCCESS_REQUEST',
    payload: { operacaoprerecebimentolista },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoprerecebimentolista/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoprerecebimentolista/RECORD_FILTERING',
    payload: { params },
  };
}
